export function buildAdTag({
  adUnitPath,
  custParams,
  pageUrl,
}: {
  adUnitPath: string; // '/13212770/cms/news_content'
  custParams?: string; // 'k=v&k=v2'
  pageUrl: string; // window.location.href
}) {
  const url = new URL("https://pubads.g.doubleclick.net/gampad/ads");

  url.searchParams.set("iu", adUnitPath);
  url.searchParams.set("gdfp_req", "1");
  url.searchParams.set("env", "vp");
  url.searchParams.set("output", "xml_vast4");
  url.searchParams.set("unviewed_position_start", "1");
  url.searchParams.set("sz", "1920x1080");
  url.searchParams.set("ciu_szs", "1920x1080");
  url.searchParams.set("vpos", "preroll");
  url.searchParams.set("description_url", pageUrl);
  url.searchParams.set("leafly_debug", "1");

  url.searchParams.set("url", pageUrl);
  if (custParams) {
    url.searchParams.set("cust_params", custParams);
  }

  return url.toString();
}
